<template>
  <span>
    <Upload
      action="/api/upload/upload"
      :on-success = "upload"
      :on-remove="uploadRemove"
    >
      <slot name="main">
        <Button icon="ios-cloud-upload-outline" size="small" :disabled="count>0">选择视频文件（支持.mp4,.mov）</Button>
      </slot>
    </Upload>
  </span>
</template>

<script>
  export default {
    props:{
      value:{
        type:String,
        default:''
      }
    },
    data(){
      return{
        count:0,
      }
    },
    methods:{
      upload(response, file, fileList){
        this.value = response.upload.uuid;
        this.$emit('input',this.value);
        this.count++;
      },
      uploadRemove(file, fileList){
        this.value = '';
        this.$emit('input',this.value);
        this.count--;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/upload/UploadUUID.vue